import { __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { default as AddToBagVerificationComposition } from "@hm-group/cart-compositions/AddToBagVerification";
import cn from 'classnames';
import { Transition } from 'react-transition-group';
import Portal from "../../helpers/Portal";
import styles from './AddToBagVerification.module.scss';
import ErrorContent from './components/ErrorContent/ErrorContent';
import SuccessContent from './components/SuccessContent/SuccessContent';
import { CART_URL } from './helpers/constants';
import { getAddToBagVerificationCompositionProduct } from './helpers/getAddToBagVerificationCompositionProduct';
const AddToBagVerification = (_a) => {
    var _b;
    var { isShowing = false, isError = false, hasBorder = false, hasFullBorder = false, transitionFrom = 'right', size = 'small', onExit, labels, productInformation, offerInformation, timespan, addToBagVerificationCompositionLabels, shoppingBagItems } = _a, props = __rest(_a, ["isShowing", "isError", "hasBorder", "hasFullBorder", "transitionFrom", "size", "onExit", "labels", "productInformation", "offerInformation", "timespan", "addToBagVerificationCompositionLabels", "shoppingBagItems"]);
    const [shouldShow, setShouldShow] = useState(false);
    const isNorthstarBrand = process.env.BRAND_PREFIX === 'northstar';
    useEffect(() => {
        let timer;
        if (isShowing && timespan) {
            setShouldShow(true);
            timer = window.setTimeout(() => {
                setShouldShow(false);
            }, timespan);
        }
        else {
            setShouldShow(isShowing);
        }
        return () => {
            window.clearTimeout(timer);
        };
    }, [isShowing]);
    const handleExit = () => {
        if (onExit) {
            onExit();
        }
    };
    let successContent;
    if (isNorthstarBrand &&
        ((_b = productInformation === null || productInformation === void 0 ? void 0 : productInformation.productTileData) === null || _b === void 0 ? void 0 : _b.data) &&
        addToBagVerificationCompositionLabels) {
        successContent = (React.createElement(AddToBagVerificationComposition, { count: `${shoppingBagItems || 1}`, product: getAddToBagVerificationCompositionProduct(productInformation.productTileData.data, productInformation.productTileData.tableData), labels: addToBagVerificationCompositionLabels, cartUrl: CART_URL }));
    }
    else {
        successContent = (React.createElement(SuccessContent, Object.assign({ productInformation: productInformation, offerInformation: offerInformation, onClose: () => setShouldShow(false), labels: labels, shoppingBagItems: shoppingBagItems }, props)));
    }
    return (React.createElement(Transition, { in: shouldShow, timeout: 300, appear: true, onExited: handleExit }, (transitionState) => (React.createElement(Portal, null,
        React.createElement("div", { className: cn(styles.container, styles[transitionState], hasFullBorder && styles.fullBorder, isError ? (hasFullBorder ? styles.isErrorWithFullBorder : styles.isError) : '', hasBorder && styles.border, styles[`${transitionFrom}Transition`], styles[size]), "aria-live": "polite" }, isError ? React.createElement(ErrorContent, { labels: labels }) : successContent)))));
};
export default AddToBagVerification;
//# sourceMappingURL=AddToBagVerification.js.map